import { alpha } from "@mui/system"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { FORM_TABS, IForm } from "form/model"
import { getForm } from "form/tools/common"
import { PageLoading } from "page/components/PageLoading"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { ContentAudience } from "./ContentAudience"
import { ContentConfiguration } from "./ContentConfiguration"
import { ContentCreatives } from "./ContentCreatives"
import { ContentGeoTargets } from "./ContentGeoTargets"
import { ContentScreens } from "./ContentScreens"

interface IContentProps {
  form: IForm
}

const ContentFn = React.memo(
  ({
    form: {
      activeTab,
      context: { isSavingCampaign }
    }
  }: IContentProps): JSX.Element => (
    <FlexBox
      id="form-content-container"
      fullWidth
      vertical
      ai="start"
      jc="start"
      sx={{
        mt: "1rem",
        position: "relative",
        height: "calc(100% - 8rem)",
        minHeight: "calc(100% - 8rem)",
        maxHeight: "calc(100% - 8rem)",
        overflow: "auto"
      }}>
      {activeTab === FORM_TABS.CONFIGURATION ? (
        <ContentConfiguration />
      ) : activeTab === FORM_TABS.GEO_TARGETS ? (
        <ContentGeoTargets />
      ) : activeTab === FORM_TABS.SCREENS ? (
        <ContentScreens />
      ) : activeTab === FORM_TABS.AUDIENCE ? (
        <ContentAudience />
      ) : (
        <ContentCreatives />
      )}
      {isSavingCampaign && (
        <FlexBox sx={{ position: "absolute", width: "100%", height: "100%", backgroundColor: alpha("#000000", 0.1) }}>
          <FlexBox sx={{ p: "2rem", minWidth: "70%", backgroundColor: theme => theme.palette.background.default }}>
            <PageLoading title={translate("label.saving")} />
          </FlexBox>
        </FlexBox>
      )}
    </FlexBox>
  )
)

export const Content = connect(
  (state: IRootState): IContentProps => ({
    form: getForm(state)
  })
)(ContentFn)
